import React from "react";
import FormLayerCloseCta from "../FormLayerCloseCta/FormLayerCloseCta";
import CONST from "../../config/CONST";
import {useTranslation} from "react-i18next";
import VehicleDetails from "../VehicleDetails/VehicleDetails";
import numberFormat, {formatMileage, formatPrice} from "../../helpers/numberFormat";
import {useSelector} from "react-redux";
import {getFinancialConfiguration} from "../../store/slices/financialConfigurationsSlice";
import {getAppData} from "../../store/slices/appSlice";
import ResultTableItem from "../ResultTableItem/ResultTableItem";
import {getSelectedCustomer} from "../../store/slices/userConfigurationsSlice";

const FormLayerHeader = () => {

    const { t } = useTranslation();

    const appData = useSelector(getAppData);
    const financialProductConfiguration = useSelector(getFinancialConfiguration);
    const selectedCustomer = useSelector(getSelectedCustomer) || appData.touchpointConfig.defaults.customer;

    if(!financialProductConfiguration || !appData || !appData.input) {
        return null;
    }

    return (
        <>
            <div className={`${CONST.CSS_NAMESPACE}FormLayerHeader`}>
                <FormLayerCloseCta />
                <h1 className={`${CONST.CSS_NAMESPACE}FormLayerHeader-title`}>{t(`FormLayerHeader.title`)}</h1>
                <div className={`${CONST.CSS_NAMESPACE}FormLayerHeader-wrapper`}>
                    <div className={`${CONST.CSS_NAMESPACE}row`}>
                        <div className={`${CONST.CSS_NAMESPACE}col-md-6 ${CONST.CSS_NAMESPACE}no-padding`}>
                            <VehicleDetails
                                financialProductConfiguration={financialProductConfiguration}
                                price={appData.input.price}
                                formatValue={value => `${appData.config.marketConfig.currencySymbol} ${numberFormat(value, appData.config.marketConfig.decimalPlaces, appData.config.marketConfig.decimalSeparator, appData.config.marketConfig.thousandsSeparator, false)}`}
                                cashPriceDisclaimer= {t(`VATDisclaimer_${financialProductConfiguration?.selectedCustomer}`)}
                                isVehiclePriceVisible={false}
                            />
                        </div>
                        <div className={`${CONST.CSS_NAMESPACE}col-md-6 ${CONST.CSS_NAMESPACE}no-padding`}>
                            <ResultTableItem
                                label={`${financialProductConfiguration.rentalProductName}`}
                                className={`${CONST.CSS_NAMESPACE}formLayer-Header-details-highlighted`}
                            />
                            <ResultTableItem
                                label={t(`TotalInstallment_${financialProductConfiguration.productTypeCode}`)}
                                value={formatPrice(appData, financialProductConfiguration.totalInstallment, 2, false)}
                                className={`${CONST.CSS_NAMESPACE}formLayer-Header`}
                                vatDisclaimer={t(`VATDisclaimer_${selectedCustomer}`)}
                            />
                            <div className={`${CONST.CSS_NAMESPACE}FormLayerHeader-details-container`}>
                                <ResultTableItem
                                    value={`${financialProductConfiguration.duration} ${t(`FormLayerHeader.Months`)}`}
                                    className={`${CONST.CSS_NAMESPACE}formLayer-Header-details`}
                                />
                                <ResultTableItem
                                    value={`${formatMileage(appData, financialProductConfiguration.mileage, false, false)} ${t(`FormLayerHeader.Mileage`)}`}
                                    className={`${CONST.CSS_NAMESPACE}formLayer-Header-details no-border`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FormLayerHeader;